module.exports = __webpack_public_path__ + "static/media/bg-shape-n1.a10ef431.png";